import { Button, Rate } from 'antd';
import styled from 'styled-components';

export const StyledFloatButton = styled(Button)`
  position: absolute;
  bottom: 1%;
  right: 1%;
  z-index: 99;

`;

export const StyledRate = styled(Rate)`
  color: #FFA500;
  .ant-rate-star-first, .ant-rate-star-second {
    color: rgba(94, 89, 89, 0.25)
  }
`;
